export const NAVIGATION_ROUTES = [
  {
    routeName: "dashboard",
    key: "dashboard",
    translationPath: "navbar.dashboard",
    icon: "dashboard"
  },
  {
    routeName: "offers",
    key: "offers",
    translationPath: "navbar.offers",
    icon: "offers"
  },
  {
    routeName: "orders",
    key: "orders",
    translationPath: "navbar.orders",
    icon: "orders"
  },
  {
    routeName: "returns",
    key: "returns",
    translationPath: "returns.title",
    icon: "returns"
  },
  // Роут перестав використовуватись через перехід на систему комісії
  //
  // {
  //   translationPath: 'navbar.adversting.title',
  //   icon: 'adversting',
  //   key: 'adversting',
  //   routeName: 'adversting'
  // },
  {
    routeName: "reviews",
    key: "reviews",
    translationPath: "navbar.reviews",
    icon: "reviews"
  },
  {
    routeName: "delivery",
    key: "delivery",
    translationPath: "navbar.delivery",
    icon: "delivery"
  },
  {
    key: "sync",
    translationPath: "synchronization.title",
    icon: "synchronization",
    nestedRouters: [
      {
        routeName: "sync-list",
        key: "sync-list",
        translationPath: "synchronization.sub_title_1"
      },
      {
        routeName: "sync-rules",
        key: "sync-rules",
        translationPath: "synchronization.sub_title_2"
      }
    ]
  },
  {
    routeName: "support",
    key: "support",
    translationPath: "support.title",
    icon: "support"
  },
  {
    routeName: "sellerKeys",
    key: "seller_keys",
    translationPath: "navbar.keys",
    icon: "keys"
  },
  // Роут перестав використовуватись через перехід на систему комісії
  // {
  //   routeName: 'subscribers',
  //   key: 'subscribers',
  //   translationPath: 'subscribers.title',
  //   icon: 'subscribers'
  // },
  {
    routeName: "tariffs",
    key: "tarrifs",
    translationPath: "tariffs.title",
    icon: "tarrifs",
    nestedRouters: [
      {
        routeName: "tariffInvoices",
        key: "tariffInvoices",
        translationPath: "tariffs.invoices.title"
      },
      {
        routeName: "cpaStatistics",
        key: "cpaStatistics",
        translationPath: "navbar.adversting.cpa_statistics"
      }
    ]
  }
]
